import * as React from 'react';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { Dropdown } from '../srp/sort-filter/dropdown';
import { FilterPills } from '../srp/sort-filter';
import { ShopWithPointsToggle } from './shop-with-points-toggle';
import { SortDisclaimer } from './sort-disclaimer';
export var ActivityAssortedCard = function (_a) {
  var _b, _c;
  var data = _a.data;
  var sortSection = data.sortSection,
    sortDisclaimer = data.sortDisclaimer,
    shopWithPoints = data.shopWithPoints,
    pills = data.pills;
  var _d = pills || {},
    appliedFilters = _d.appliedFilters,
    clearAll = _d.clearAll;
  var clickAction = clearAll === null || clearAll === void 0 ? void 0 : clearAll.action;
  var relativePath = (_b = clickAction === null || clickAction === void 0 ? void 0 : clickAction.resource) === null || _b === void 0 ? void 0 : _b.relativePath;
  return React.createElement(React.Fragment, null, (appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.length) > 0 && React.createElement(FilterPills, {
    filters: appliedFilters,
    clearLabel: clearAll === null || clearAll === void 0 ? void 0 : clearAll.primary,
    clearAnalytics: clickAction === null || clickAction === void 0 ? void 0 : clickAction.analytics,
    clearURL: relativePath
  }), React.createElement(UitkSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement("div", null, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(UitkLayoutGrid, {
    columns: 3,
    space: "two"
  }, React.createElement(UitkLayoutGridItem, {
    colSpan: 2
  }, React.createElement(UitkLayoutFlex, {
    justifyContent: "space-between"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutFlex, {
    direction: "column",
    justifyContent: "space-between"
  }, React.createElement(UitkLayoutFlexItem, null, shopWithPoints && React.createElement(ShopWithPointsToggle, {
    data: shopWithPoints
  })), React.createElement(UitkLayoutFlexItem, null, sortDisclaimer && React.createElement(SortDisclaimer, {
    data: sortDisclaimer
  })))))), React.createElement(UitkLayoutGridItem, null, (sortSection === null || sortSection === void 0 ? void 0 : sortSection.fields[0]) && React.createElement(Dropdown, {
    field: sortSection === null || sortSection === void 0 ? void 0 : sortSection.fields[0],
    inDialog: false,
    title: (_c = sortSection === null || sortSection === void 0 ? void 0 : sortSection.fields[0]) === null || _c === void 0 ? void 0 : _c.primary
  })))), React.createElement(ViewSmall, null, React.createElement(React.Fragment, null, shopWithPoints && React.createElement(ShopWithPointsToggle, {
    data: shopWithPoints
  }), sortDisclaimer && React.createElement(SortDisclaimer, {
    data: sortDisclaimer
  })))))));
};